import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      lang: "en",
      People: "People",
      Media: "Media Segments",
      Organizations: "Organizations",
      About: "About",
      Theory: "Theory",
      Diagram: "RUCR",
      "Why care": "Why care?",
      Language: "Language",
      Search: "Search",
      "Wapaganda Project": "Wapaganda Project",
      Gender: "Gender",
      "years old": "years old",
      Biography: "Biography",
      Born: "Born",
      Age: "Age",
      Associates: "Associates",
      Name: "Name",
      Relationship: "Relationship",

      "Social networks presence": "Social networks presence",
      "Known contact information": "Known contact information",
      "Known addresses": "Known addresses",
      "Additional details": "Additional details",
      "Also featured on": "Also featured on",
      "Claimed expertise": "Claimed expertise",
      "Has affiliation with": "Has affiliation with",
      "info could be outdated": "info could be outdated",

      ORGANIZATIONS: "ORGANIZATIONS",
      NAME: "NAME",
      "ORG TYPE": "ORG TYPE",
      "ORG FORM": "ORG FORM",
      "PARENT ORG": "PARENT ORG",
      "No available info yet": "No available info yet",
      "Submit data": "Submit data",
      "AIR TIME": "AIR TIME",
      "Coming soon": "Coming soon",
      "CHANNEL NAME": "CHANNEL NAME",
      "DATE STARTED": "DATE STARTED",
      "CURRENT POPULATION": "CURRENT POPULATION",

      "Sort by": "Sort by",
      Filters: "Filters",
      Stats: "Stats",

      Default: "Default",
      "A-Z": "A-Z",
      "Z-A": "Z-A",
      all: "all",
      GENDER: "GENDER",
      Male: "Male",
      Female: "Female",
      STATUS: "STATUS",
      alive: "alive",
      dead: "dead",
      Sort: "Sort",
      AGE: "AGE",
      Flags: "Flags",
      expertise: "expertise",
      groups: "groups",

      "Original text was published by": "Original text was published by",
      "in his Telegram channel on": "in his Telegram channel on",
      "Original text": "Original text",
      svgUrl:
        "https://res.cloudinary.com/dyndxow8x/image/upload/v1699102083/wapaganda/diagram/rucr.drawioEN-SVG_hejy2q.svg",
      "people involved text":
        "Meet some people engaged in disseminating the narratives of the Russian propaganda. Soldiers, PhDs, journalists, politicians - they are all here... And if we're missing someone, ",
      "do let us know!": "do let us know!",
      "people involved": "people",

      "Ruskymir Creed (RUCR)": "Ruskymir Creed (RUCR)",
      "Ruskymir Creed (RUCR) content":
        "What you can see here is a model of concepts and ideas commonly re-used by the Russian propaganda on the daily basis. It is currently comprised of {{number_of_concepts}} concepts (or tropes, as we call them)  touching on all kinds of topics, from abortions to moon landing, but mainly concerned with diminishing and lying about Ukraine and its people. These are the ideas you'd hear if you were to turn on any today's Russian media outlet, apart from the exiled political opposition and those that focus on entertainment exclusively - although, this last category is far from innocent, as more and more singers, poets and producers turn to suck from the perennial tit of the state. You will notice that some of them would explicitly contradict others - this is normal, because it reflects the actual state of affairs, where people with, sometimes, diametrically opposing views unite in the blind adoration of Vladimir Putin's activities, jokes and speeches. If you're wondering, how exactly is this even possible, - this entire project is dedicated to finding the answer to this question. We believe that RUCR is a step in the direction of it.",
      "How it works": "How it works",
      "How it works content":
        "RUCR is based on the Simple Knowledge Organization System (SKOS), which is a standard developed by World Wide Web Consortium (also known as W3C) in >>>> mainly for representing existing systems of knowledge (such as library catalogs) in digital format. What's important to know, is that it defines 2 kinds of relations: the broader - narrower kind is hierarchical and says that a certain idea is broader or narrower in relation to another certain idea; and related kind says that two ideas are connected in a non-hierarchical way. For example, the idea that homosexuality is a sin is narrower to the idea that homosexuality is wrong; and that latter one is related to the idea that liberal values were made up as a tool for disrupting nations from within. Arrows on the diagram represent broader / narrower relationships, with the arrowhead pointing to the broader term. Representing related relations is under development. Two large circles contain the 15 core ideas: they are considered such because themselves they cannot be broken down any further (well, kind of - see the WIP note below). One of the circles contains anti-Ukrainian collection, the other - everything else. This layout is quite arbitrary, that is - dictated by aesthetics mostly; however the defined relations are solid.",
      WIP: "WIP",
      "WIP content":
        "RUCR is not a finished work: some concepts may not have been identified yet, others are yet to arise - this terrain is complex and fluid, and capturing and analyzing it takes time and work. If you feel like you can help us move things forward, send us a letter.",
      "View full size": "View full size",

      By: "By",
      Acknowledgments: "Acknowledgments",
      "Technical Documentation": "Technical",
      "About Us": "About Us",
      Contacts: "Contacts",
      Telegram: "Telegram",
      "Support the Project": "Support the Project",

      "Coming soon!": "Coming soon!",
      "We are sorry,": "We are sorry,",
      "This section is still under development":
        "this section is still under development",

      "No appearances known at this date": "No appearances known at this date",
      "Are we missing something? Let us know":
        "Are we missing something? Let us know",

      Appearances: "Appearances",
      "Time on air": "Time on air",
      "Total known air time": "Total known air time",
      "Total known appearances": "Total known appearances",
      "Appears as": "Appears as",

      "no options": "no options",
      "Oops... Seems like we're missing this one.":
        "Oops... Seems like we're missing this one.",
    },
  },
  ru: {
    translation: {
      lang: "ru",
      People: "Люди",
      Media: "Медиа-сегменты",
      Organizations: "Организации",
      About: "О нас",
      Theory: "Теория",
      Diagram: "РУКР",
      "Why care": "Зачем это все?",

      Language: "Язык",
      Search: "Поиск",
      "Wapaganda Project": "Проект Wapaganda",
      Gender: "Пол",
      "years old": "лет",
      Biography: "Биография",
      Born: "Дата рождения",
      Age: "Возраст",
      Associates: "Связи",
      Name: "Имя",
      Relationship: "Тип связи",

      "Social networks presence": "Присутствие в соцсетях",
      "Known contact information": "Контактная информация",
      "Known addresses": "Известные адреса",
      "Additional details": "Дополнительные детали",
      "Also featured on": "Также можно найти здесь",
      "Claimed expertise": "Заявленные компетенции",
      "Has affiliation with": "Аффилиации",
      "info could be outdated": "информация может быть устаревшей",

      ORGANIZATIONS: "ОРГАНИЗАЦИИ",
      NAME: "НАЗВАНИЕ",
      "ORG TYPE": "ТИП",
      "ORG FORM": "ФОРМА",
      "PARENT ORG": "МАТЕРИНСКАЯ ОРГАНИЗАЦИЯ",
      "No available info yet": "Здесь скоро что-то будет",
      "Submit data": "Добавить",
      "AIR TIME": "ЭФИРНОЕ ВРЕМЯ",
      "Coming soon": "Здесь скоро что-то будет",
      "CHANNEL NAME": "НАЗВАНИЕ",
      "DATE STARTED": "ДАТА ЗАПУСКА",
      "CURRENT POPULATION": "ЧИСЛЕННОСТЬ НАСЕЛЕНИЯ",

      "Sort by": "Сортировать",
      Filters: "Filters",
      Stats: "Stats",

      Default: "По умолчанию",
      "A-Z": "A-Z",
      "Z-A": "Z-A",
      all: "все",
      GENDER: "ПОЛ",
      Male: "М",
      Female: "Ж",
      STATUS: "СТАТУС",
      alive: "дышит",
      dead: "не дышит",
      Sort: "Сортировать",
      AGE: "ВОЗРАСТ",
      Flags: "Flags",
      expertise: "expertise",
      groups: "groups",

      "Original text was published by": "Оригинал был опубликован",
      "in his Telegram channel on": "in his Telegram channel on",
      "Original text": "Текст оригинала",
      svgUrl:
        "https://res.cloudinary.com/dyndxow8x/image/upload/v1699101955/wapaganda/diagram/rucr.drawioRU-SVG_ygmqv6.svg",
      "people involved text":
        "Здесь вы можете познакомиться с людьми, вовлеченными в распространение нарративов путинской пропаганды. Солдаты, журналисты, политики, кандидаты наук - все они здесь... А если вдруг мы кого-то упустили, ",
      "do let us know!": "напишите нам об этом!",
      "people involved": "ЛЮДИ",

      By: "",
      Acknowledgments: "Признательности",
      "Technical Documentation": "Техническое",
      "About Us": "О нас",
      Contacts: "Контакты",
      Telegram: "Telegram",
      "Support the Project": "Поддержать проект",

      "Ruskymir Creed (RUCR)": "Кредо русского мира (РУКР)",
      "Ruskymir Creed (RUCR) content":
        "То, что вы найдете здесь представляет собой модель концепций и идей, которые регулярно используются российской пропагандой. На данный момент она состоит из {{number_of_concepts}} концепций (или, как мы их называем, тропов), затрагивающих самые разные темы, от абортов до посадки на Луну, но в основном направленных на принижение Украины, и ложь о ее народе. Это те идеи, которые вы услышите, если включите любое современное российское СМИ, за исключением разве что политической оппозиции в изгнании, и тех, которые ориентированы исключительно на развлечения - впрочем, эту последнюю категорию тоже сложно назвать чистой, ведь все больше и больше певцов, поэтов, продюсеров и т.п. стараются приникнуть к непересыхающей государственной груди. Вы заметите, что некоторые из них очевидно противоречат другим - это нормально, посольку отражает реальное положение вещей, где люди с порой диаметрально противоположными взглядами сливаются в слепом обожании решений, шуток и цитат Владимира Путина. Если вы задаетесь вопросом, как это вообще возможно, - что ж, наш проект посвящен поиску ответа на этот вопрос целиком и полностью. Мы считаем, что РУКР - это шаг в правильном направлении. ",
      "How it works": "Как это работает",
      "How it works content":
        "РУКР основан на стандарте под названием Simple Knowledge Organization System (SKOS), который был разработан World Wide Web Consortium (также известным как W3C) в основном для репрезентации уже сложившихся систем знаний (таких как библиотечные каталоги) в цифровом формате. Здесь важно знать, что SKOS определяет 2 типа отношений: broader (более широкий) - narrower (более узкий) - это иерархический тип, который устанавливает, что некая идея более общая или более специфическая по отношению к некоторой другой идее; и related устанавливает не-иерархическую связь между концептами. Например, идея, что гомосексуализм - это грех, уже по отношению к идее, что гомосексуализм - это плохо, которая в свою очередь связана с идеей, что либеральные ценности были изобретены в качестве инструмент для разрушения наций изнутри. Связи на диаграмме представляют отношения шире / уже, причем стрелка указывает на более широкий термин. Репрезентация related отношений пока что в разработке. Два больших круга содержат 15 корневых идей: мы считаем их таковыми, потому что в отношении них дальнейшая детализация затруднительна (однако см. примечание ниже). Один из них содержит коллекцию антиукраинских идей, другой - все прочее. Такая структура вполне произвольна, то есть, продиктовано преимущественно эстетикой; однако те отношения, которые определены между концептами, - в порядке.",
      WIP: "Работа продолжается",
      "WIP content":
        "РУКР не является завершенным проектом: какие-то идеи возможно еще идентифицированы, другим еще предстоит проявиться - это территория сложная и изменчивая, сбор и анализ информации требуют времени и труда. Если вы думаете, что можете помочь нам продвинуться дальше, напишите нам письмо.",
      "View full size": "Полный размер",

      "Coming soon!": "Скоро!",
      "We are sorry,": "К сожалению,",
      "This section is still under development":
        "этот раздел все еще в разработке",

      "No appearances known at this date": "No appearances known at this date",
      "Are we missing something? Let us know":
        "Are we missing something? Let us know",

      Appearances: "Appearances",
      "Time on air": "Time on air",
      "Total known air time": "Total known air time",
      "Total known appearances": "Total known appearances",
      "Appears as": "Appears as",

      "no options": "no options",
      "Oops... Seems like we're missing this one.":
        "Oops... Seems like we're missing this one.",
    },
  },
  uk: {
    translation: {
      lang: "uk",
      People: "Люди",
      Media: "Медіа-сегменти",
      Organizations: "Організації",
      About: "Про нас",
      Theory: "Теорія",
      Diagram: "РУКР",
      "Why care": "Нащо оце все?",

      Language: "Мова",
      Search: "Пошук",
      "Wapaganda Project": "Проект Wapaganda",
      Gender: "Стать",
      "years old": "років",
      Biography: "Біографія",
      Born: "Дата народження",
      Age: "Рік",
      Associates: "Зв'язки",
      Name: "Им'я",
      Relationship: "Тип зв'язку",

      "Social networks presence": "Присутність в соцсітях",
      "Known contact information": "Контактна інформація",
      "Known addresses": "Відомі адреси",
      "Additional details": "Додадкові деталі",
      "Also featured on": "Також можна знайти тут",
      "Claimed expertise": "Заявлені компетенції",
      "Has affiliation with": "Афіліації",
      "info could be outdated": "інформація може бути застарілою",

      ORGANIZATIONS: "ОРГАНІЗАЦІЇ",
      NAME: "НАЗВА",
      "ORG TYPE": "ТИП",
      "ORG FORM": "ФОРМА",
      "PARENT ORG": "ГОЛОВНА ОРГАНІЗАЦІЯ",
      "No available info yet": "Тут скоро щось буде",
      "Submit data": "Додати",
      "AIR TIME": "Етерний час",
      "Coming soon": "Тут скоро щось буде",
      "CHANNEL NAME": "НАЗВА",
      "DATE STARTED": "ДАТА ЗАПУСКУ",
      "CURRENT POPULATION": "ЧИСЕЛЬНІСТЬ НАСЕЛЕННЯ",

      "Sort by": "Сортувати",
      Filters: "Filters",
      Stats: "Stats",

      Default: "За замовчуванням",
      "A-Z": "A-Z",
      "Z-A": "Z-A",
      all: "всі",
      GENDER: "СТАТЬ",
      Male: "Ч",
      Female: "Ж",
      STATUS: "СТАТУС",
      alive: "дихає",
      dead: "не дихає",
      Sort: "Сортування",
      AGE: "РІК",
      Flags: "Flags",
      expertise: "expertise",
      groups: "groups",

      "Original text was published by": "Оригінал було опублковано",
      "in his Telegram channel on": "in his Telegram channel on",
      "Original text": "Текст оригіналу",
      svgUrl:
        "https://res.cloudinary.com/dyndxow8x/image/upload/v1699101945/wapaganda/diagram/rucr.drawioUA-SVG_yijluf.svg",
      "people involved text":
        "Тут ви можете ознайомитися з тими, хто займається розповсюдженням нарративів російської пропаганди. Солдати, журналісти, політичні діячи, кандидати наук - всі вони тут... А якщо раптом ми когось проґавили, ",
      "do let us know!": "надішліть нам листа!",
      "people involved": "ЛЮДИ",

      By: "",
      Acknowledgments: "Наша подяка",
      "Technical Documentation": "Технічне",
      "About Us": "Про нас",
      Contacts: "Контакти",
      Telegram: "Telegram",
      "Support the Project": "Підтримати проект",

      "Ruskymir Creed (RUCR)": "Кредо руського миру (РУКР)",
      "Ruskymir Creed (RUCR) content":
        "Те, що ви тут бачите, є моделлю концепцій та ідей, які російська пропаганда використовує постійно. Наразі вона складається з {{number_of_concepts}} концепцій (або тропів, як ми їх називаємо), які стосуються всіляких тем, від абортів до приземлення на місяць, але головним чином спрямовані на применшення та брехню про Україну та її людей. Це ті ідеї, які ви почуєте, якщо ввімкнете будь-який сучасний російський медіа-ресурс, за винятком політичної опозиції у вигнанні, та тих, що зосереджуються винятково на розвагах - хоча ця остання категорія теж далека не безвинна, оскільки все більше співаків, поетів та продюсерів обирають намагаються припасти до непересихаючих державних грудей. Ви помітите, що деякі з них вочевидь суперечать іншим - це нормально, оскільки відображає реальний стан речей, коли люди, з іноді діаметрально протилежними поглядами, об'єднуються в сліпому захопленні рішеннями, діяльністью, жартами та цитатами Володимира Путіна. Якщо ви цікавитесь, як це взагалі можливо, - весь наш проект присвячено пошуку відповіді на це питання. Ми вважаємо, що РУКР - це крок у цьому напрямку.",
      "How it works": "Як це працює",
      "How it works content":
        "РУКР базується на стандарті під назвою Simple Knowledge Organization System (SKOS), який був розроблен World Wide Web Consortium (відомим як W3C) в >>>> головним чином для репрезентації існуючих систем знань (таких як бібліотечні каталоги) в цифровому форматі. Важливо знати, що вона визначає 2 типи відносин: broader (ширше) - narrower (вужче) - це ієрархічний тип, який встановлює, що певна ідея є більш загальною або більш специфічною відносно іншої певної ідеї; а related встановлю не-ієрархічний зв'язок між двома ідеями. Наприклад, ідея, що гомосексуалізм є гріхом, є вужчою за ідею, що гомосексуалізм це погано, а ця остання, в свою чергу,пов'язана з ідеєю, що ліберальні цінності були вигадані як інструмент для руйнування націй зсередини. Стрілки на діаграмі представляють відносини ширше / вужче, та вказують на ширший термін. Репрезентація пов'язаних відносин наразі у розробці. Два великих кола містять 15 корінних ідей: ми вважаємо їх такими, тому що з них складно вивести концепти ще більш загальні (але див. нижче). Одне з кіл містить колекцію антиукраїнських ідей, друге - все інше. Ця структура досить довільна, тобто продиктована переважно естетикою; однак визначені нами відносини є обґрунтованими.",
      WIP: "Робота продовжується ",
      "WIP content":
        "РУКР не є довершеною роботою: деякі концепції ще, можливо, не виявлені, інші тільки мають з'явитися - ця область складна і дуже швидкоплинна; її вивчення та аналіз займають час і потребують праці. Якщо ви відчуваєте, що можете допомогти нам просувати це все вперед, надішліть нам листа.",
      "View full size": "Дивитися ближче",

      "Coming soon!": "Незабаром!",
      "We are sorry,": "На жаль,",
      "This section is still under development": "цей розділ все ще у розробці",

      "No appearances known at this date": "No appearances known at this date",
      "Are we missing something? Let us know":
        "Are we missing something? Let us know",

      Appearances: "Appearances",
      "Time on air": "Time on air",
      "Total known air time": "Total known air time",
      "Total known appearances": "Total known appearances",
      "Appears as": "Appears as",

      "no options": "no options",
      "Oops... Seems like we're missing this one.":
        "Oops... Seems like we're missing this one.",
    },
  },
};

// noinspection JSIgnoredPromiseFromCall
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain",
      ],
      caches: ["localStorage", "cookie"],
      lookupQuerystring: "lang",
      lookupCookie: "i18next",
      lookupLocalStorage: "i18nextLng",
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
      checkWhitelist: true,
    },
  });

export default i18n;
